// extracted by mini-css-extract-plugin
export default {"layout":"PcptC","inner":"Rqcds","withBanner":"UkskX"};